// Per-treatment GHL calendar config.
// Each slug maps to a GHL booking widget ID. If a slug isn't listed, falls back to DEFAULT.
// Override per-treatment by setting REACT_APP_GHL_CAL_<SLUG_UPPER_SNAKE> in frontend/.env.
const env = process.env;

const CAL = {
  injectables: "Bz6aPtbwrUrlEVOdYKs9",
  laser:       "IqXWMS4zhIdBmOFSjNk1",
  wellness:    "KVA3O20I6xgXUkA39nef",
  threads:     "g6ZAteRx1bUkyeXOyBJj",
  facials:     "mANFg4WzDjEEcR0SRV4O",
};

const TREATMENTS = {
  // Injectables
  "botox":                    { name: "Botox", category: "injectables" },
  "dermal-filler":            { name: "Dermal Filler", category: "injectables" },
  "sculptra":                 { name: "Sculptra", category: "injectables" },
  "lip-filler":               { name: "Lip Filler", category: "injectables" },
  "radiesse":                 { name: "Radiesse", category: "injectables" },
  "non-surgical-rhinoplasty": { name: "Non-Surgical Rhinoplasty", category: "injectables" },
  "injectables":              { name: "Injectables", category: "injectables" },
  // Lasers & special
  "hollywood-peel":           { name: "Hollywood Peel", category: "laser" },
  "laser-hair-removal":       { name: "Laser Hair Removal", category: "laser" },
  "microneedling":            { name: "Microneedling", category: "laser" },
  "rf-skin-tightening":       { name: "RF Skin Tightening", category: "laser" },
  "body-contouring":          { name: "Body Contouring", category: "laser" },
  "hifu-microneedling":       { name: "HIFU + Microneedling", category: "laser" },
  "laser":                    { name: "Laser & Skin", category: "laser" },
  "laser-special":            { name: "Laser & Skin", category: "laser" },
  // Facials
  "hydrafacial":              { name: "HydraFacial", category: "facials" },
  "vampire-facial":           { name: "Vampire Facial (PRP)", category: "facials" },
  "facials":                  { name: "Facials", category: "facials" },
  // Threads
  "pdo-thread-lift":          { name: "PDO Thread Lift", category: "threads" },
  "collagen-threads":         { name: "Collagen Threads", category: "threads" },
  "threads":                  { name: "Threads", category: "threads" },
  // Wellness
  "iv-vitamin-therapy":       { name: "IV Vitamin Therapy", category: "wellness" },
  "free-consultation":        { name: "Free Consultation", category: "wellness" },
  "wellness":                 { name: "Wellness", category: "wellness" },
};

export function getTreatment(slug) {
  const t = TREATMENTS[slug];
  if (!t) return { name: "Appointment", category: "wellness", calendarId: CAL.wellness };
  // Per-slug env override
  const upper = slug.toUpperCase().replace(/-/g,"_");
  const override = env[`REACT_APP_GHL_CAL_${upper}`];
  return { ...t, calendarId: override || CAL[t.category] };
}

export const ALL_TREATMENT_SLUGS = Object.keys(TREATMENTS);
